import { Link, Outlet } from 'react-router-dom';

export function PublicShell() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="border-b border-border sticky top-0 z-30 bg-background/90 backdrop-blur">
        <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
          <Link to="/" className="font-semibold text-lg tracking-tight">Ivrello</Link>
          <nav className="flex items-center gap-2 sm:gap-4 text-sm">
            <Link to="/contact" className="text-muted-foreground hover:text-foreground px-2 py-1.5">Contact</Link>
            <Link
              to="/login"
              className="inline-flex items-center rounded-md border border-border px-3 py-1.5 text-sm hover:bg-secondary"
            >
              Log in
            </Link>
          </nav>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-border py-6">
        <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 text-xs text-muted-foreground">
          © Ivrello. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
